/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connections_ConnectInputs */



/**
* | output |
* | --- |
* | "Connect" |
*
* @param {Connections_ConnectInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const connections_connect = /** @type {((inputs?: Connections_ConnectInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connections_ConnectInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Koppelen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Connecter")
	return /** @type {LocalizedString} */ ("Connect")
});